import { createAction } from '@reduxjs/toolkit';

/** @type {import('@reduxjs/toolkit').ActionCreatorWithPayload<string>} */
export const nativeSetStatusBarAttributes = createAction(
    'NATIVE::SET_STATUS_BAR_ATTRIBUTES',
);
